export function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function fixFloatingPoint(number: number, decimal = 2) {
  const floater = 10 ** decimal;
  if (decimal === 0) {
    Math.floor(number);
  }
  return Math.floor(number * floater) / floater;
}
